module.exports = [{
      plugin: require('/apps01/Jenkins/workspace/fox.uikit/fox.uikit.deploy.nonprod/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
